/**
 * 舆情设置弹窗左侧高度自适应
 */
"use strict";
angular.module("leftTabAdaptModule", []).
directive("leftTabAdapt", ['$timeout',function($timeout) {
    return {
        restrict: "A",
        replace: false,
        scope: false,
        link: function(scope, $elem, $attrs) {
            $timeout(init,100);
            // init();
            /**
             * [init description] 初始化
             * @return {[type]} [description]
             */
            function init() {
                var windowHeight = $('.adapter_container').height();
                $elem.css("height", windowHeight);
            }
        }
    };
}]);